module.exports = __webpack_public_path__ + "static/media/atos-maven-wave-logo.b86e8f87.png";